interface ValidateTargetOptions {
	target: HTMLElement
	selectorString: string
	nodeName: string | string[]
}

/**
 * Validate a target
 * @param options Options
 * @param options.target Target element
 * @param options.selectorString Any valid CSS selector string (class, id, attribute) with Element.matches()
 * @param options.nodeName List of possible nodes name
 * @returns Wether the target is valid
 */
export default function validateTarget({
	target,
	selectorString,
	nodeName
}: ValidateTargetOptions): boolean {
	const nodeNames = Array.isArray(nodeName) ? nodeName : [nodeName]
	return nodeNames.some(
		(item) => target.nodeName.toLowerCase() === item && target.matches(selectorString)
	)
}
